/**
 * Server entitlement hook for the web client (mirrors mobile use-entitlement.ts).
 *
 * The server is the gate of record — this hook is what every feature-gate check
 * reads. Stale-time matches the server-side 60s cache so re-fetches are cheap.
 */
import type { Entitlement } from '@nutians/shared/schemas';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../api.js';

export const ENTITLEMENT_KEY = ['entitlement'] as const;

export function useEntitlement(enabled = true) {
  return useQuery({
    queryKey: ENTITLEMENT_KEY,
    queryFn: async (): Promise<Entitlement> => {
      const { data, error } = await api.GET('/me/entitlement');
      if (error || !data) throw new Error('GET /me/entitlement failed');
      return data;
    },
    enabled,
    staleTime: 60_000,
    retry: false,
  });
}

export function useInvalidateEntitlement() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: ENTITLEMENT_KEY });
}
